// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"422":"media-overlay","536":"debug-bar","715":"details-modal","835":"variant-selection","979":"swiper"}[chunkId] + ".js";
};